// Module
var code = `<div class="col-lg-12">
    <bfg-chart name="economics.CampaignProgressByInstallDate"></bfg-chart>
</div>

<installs-table rows="rows"></installs-table>
`;
// Exports
module.exports = code;